import { render, staticRenderFns } from "./ResetPasswordSteps.vue?vue&type=template&id=3ec85874&scoped=true"
import script from "./ResetPasswordSteps.vue?vue&type=script&lang=js"
export * from "./ResetPasswordSteps.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordSteps.vue?vue&type=style&index=0&id=3ec85874&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec85874",
  null
  
)

export default component.exports